import PropTypes from 'prop-types';
import {DataTypeProvider} from '@devexpress/dx-react-grid';
import Chip from '@material-ui/core/Chip';
import {amber, grey, green, red} from '@material-ui/core/colors';

const SbsStatusFormatter = ({value}) => {
  let statusColour = 'inherit';
  let textColour = 'white';

  switch (value) {
    case 'Completed':
      statusColour = green['400'];
      break;
    case 'WIP':
      statusColour = amber['300'];
      textColour = grey['700'];
      break;
    case 'Kaizen':
      statusColour = grey['500'];
      break;
    case 'Outdated':
      statusColour = red['300'];
      break;
    default:
      break;
  }

  return (
    <Chip
      label={value}
      style={{marginRight: 8, backgroundColor: statusColour, color: textColour}}
    />
  );
};
const SbsStatusProvider = (props) => (
  <DataTypeProvider formatterComponent={SbsStatusFormatter} {...props} />
);

SbsStatusFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

export default SbsStatusProvider;
